// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1_F6D","content":"styles_content__2Brae","selectAll":"styles_selectAll__AZEN7"};